// var urlString = "http://localhost:3021/ariha-foods-api/";
var urlString = "https://api.bechofy.in/ariha-foods-api/";
// var urlString = "https://api.grubdigest.com/api-grub/";

const PostApiCall = {
  postRequest(userData, url) {
    return fetch(urlString + url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        schema: "ariha_foods",
        'x-auth-token': localStorage.getItem('access')
      },
      body: JSON.stringify(userData),
    })
      .then((response) => {
        if (response.status === 401) {
          localStorage.setItem('SessionExpired', 'true');
          localStorage.removeItem('OrderData');
          localStorage.removeItem('LoginDetailsWeb');
          // window.location.reload();
          return response;
        } else {
          return response;
        }

      })
      .catch((error) => {
        console.log("request failed", error);
        return error;
      });
  },
};

export default PostApiCall;
